import { render, staticRenderFns } from "./goodStudents.vue?vue&type=template&id=16f6681b&scoped=true"
import script from "./goodStudents.vue?vue&type=script&lang=js"
export * from "./goodStudents.vue?vue&type=script&lang=js"
import style0 from "./goodStudents.vue?vue&type=style&index=0&id=16f6681b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f6681b",
  null
  
)

export default component.exports